
import { useToast as useToastOriginal } from "@/hooks/use-toast";
import { toast as toastOriginal } from "sonner";

// Re-export the hooks with their original names
export const useToast = useToastOriginal;
export const toast = toastOriginal;
